/**
 * EmotePalette.tsx — quick-tap emoji reactions. Emits an EmoteReaction
 * TableAction when clicked; the EmoteOverlay (sibling) animates the
 * incoming emojis on every client.
 *
 * Phase 1 ships a fixed set of 8 emotes. Future expansion can let users
 * customise their palette.
 */

const EMOTES = ['👋', '🎉', '🤔', '😂', '👏', '🔥', '🎲', '🤝'] as const;

type Props = {
  onEmote: (emoji: string) => void;
};

export function EmotePalette({ onEmote }: Props) {
  return (
    <div className="absolute bottom-44 right-3 flex flex-col gap-1 bg-cosmos-900/80 backdrop-blur p-1 rounded-card ring-1 ring-cosmos-700">
      {EMOTES.map((emoji) => (
        <button
          key={emoji}
          type="button"
          onClick={() => onEmote(emoji)}
          className="w-9 h-9 flex items-center justify-center rounded hover:bg-cosmos-700 text-xl transition active:scale-90"
          aria-label={`React with ${emoji}`}
        >
          {emoji}
        </button>
      ))}
    </div>
  );
}
